import { tv } from '~/utils/tv'

export const InputMultiSelectActionsVariants = tv({
  base: `
    group flex w-full items-center justify-between gap-onepulse
    bg-forms-fill border-forms-none overflow-hidden cursor-pointer
    min-w-[calc(var(--sizing-huge)_+_var(--sizing-tiny))] focus-visible:outline-none
    `,
  variants: {
    size: {
      md: 'min-h-medium rounded-form px-threepulse',
      ml: 'min-h-mediumlarge rounded-form px-threepulse',
      lg: 'min-h-large rounded-form px-threepulse',
      xl: 'min-h-extralarge rounded-largecontainer px-threepulse',
    },
    hasError: {
      true: '',
    },
    disabled: {
      true: '',
    },
    filled: {
      true: '',
    },
    readonly: {
      true: '',
    },
    active: {
      true: '',
    },
    hasTwoItems: {
      true: '',
    },
  },
  compoundVariants: [
    {
      hasError: true,
      active: true,
      class: `
          border-forms-border-error bg-forms-fill-error
          border-halfpulse
        `,
    },
    {
      hasError: true,
      filled: true,
      active: false,
      class: `
          border border-forms-border-error bg-forms-fill-error
          hover:border-forms-border-error hover:border-halfpulse
          focus:border-forms-border-error focus:border-halfpulse
          active:border-forms-border-error active:border-halfpulse
        `,
    },
    {
      hasError: true,
      filled: false,
      active: false,
      class: `
          border-forms-border-error border-quarterpulse bg-forms-fill 
          hover:border-forms-border-error hover:bg-forms-fill-hovered hover:border-halfpulse
          focus:border-forms-border-error focus:border-halfpulse
          active:border-forms-border-error active:border-halfpulse
        `,
    },
    {
      readonly: true,
      filled: true,
      class: `
          border border-forms-border-readonly bg-forms-fill-readonly
          hover:border-forms-border-readonly hover:border-quarterpulse
          focus:border-forms-border-readonly focus:border-quarterpulse
          active:border-forms-border-readonly active:border-quarterpulse
        `,
    },
    {
      readonly: true,
      filled: false,
      class: `
          border border-forms-border-readonly bg-forms-fill-readonly
          hover:border-forms-border-readonly hover:border-quarterpulse
          focus:border-forms-border-readonly focus:border-quarterpulse
          active:border-forms-border-readonly active:border-quarterpulse

        `,
    },
    {
      disabled: true,
      filled: true,
      class: `
          border border-forms-border-disabled bg-forms-fill-disabled
          hover:border-forms-border-disabled hover:border-quarterpulse
          focus:border-forms-border-disabled focus:border-quarterpulse
          active:border-forms-border-disabled active:border-quarterpulse
        `,
    },
    {
      disabled: true,
      filled: false,
      class: `
          border border-forms-border-disabled bg-forms-fill-disabled
          hover:border-forms-border-disabled hover:border-quarterpulse
          focus:border-forms-border-disabled focus:border-quarterpulse
          active:border-forms-border-disabled active:border-quarterpulse
        `,
    },
    {
      active: true,
      filled: true,
      readonly: false,
      disabled: false,
      hasError: false,
      class:
        'cursor-pointer border-forms-border-focused border-forms-border-focused border-halfpulse bg-forms-fill-focused active:border-forms-border-focused active:border-halfpulse',
    },
    {
      active: true,
      readonly: false,
      disabled: false,
      hasError: false,
      filled: false,
      class:
        'cursor-pointer border border-forms-border-focused border-forms-border-focused border-halfpulse bg-forms-fill-focused',
    },
    {
      active: false,
      hasError: false,
      disabled: false,
      readonly: false,
      filled: true,
      class:
        'border border-forms-border-filled border-quarterpulse bg-forms-fill-filled hover:border-halfpulse focus:border-forms-border-focused focus:border-halfpulse focus:bg-forms-fill-focused active:border-forms-border-focused active:border-halfpulse active:bg-forms-fill-focused',
    },
    {
      active: false,
      hasError: false,
      disabled: false,
      readonly: false,
      filled: false,
      class: `
          focus-simple:cursor-pointer
          focus:border-halfpulse focus:border-forms-border-focused focus:cursor-pointer
          hover:border-none hover:bg-forms-fill-hovered
        `,
    },
    {
      size: 'md',
      hasTwoItems: false,
      class: 'h-medium',
    },
    {
      size: 'ml',
      hasTwoItems: false,
      class: 'h-mediumlarge',
    },
    {
      size: 'lg',
      hasTwoItems: false,
      class: 'h-large',
    },
    {
      size: 'xl',
      hasTwoItems: false,
      class: 'h-extralarge',
    },
  ],
  defaultVariants: {
    size: 'ml',
    isFocused: false,
    hasError: false,
    readonly: false,
    disabled: false,
  },
})
